import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    show_attachments_container: {
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',
        flexDirection: 'column'
    },
    attachments_container: {
        width: '100%',
        padding: '0 5px',
        display: 'flex',
        flexDirection: 'column'
    },
    attachments_grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '16px',
        width: '100%',
        padding: '8px 0'
    },
    attachment_item: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
        padding: '12px',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '8px',
        backgroundColor: theme.palette.background.paper,
        transition: 'all 0.3s ease',
        '&:hover': {
            boxShadow: theme.shadows[2],
            borderColor: theme.palette.primary.main
        }
    },
    image_wrapper: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '70px',
        height: '70px',
        backgroundColor: theme.palette.grey[100],
        borderRadius: '4px',
        overflow: 'hidden'
    },
    attachment_info: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        minWidth: 0
    },
    attachment_type: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '14px',
        fontWeight: 500
    },
    type_badge: {
        display: 'inline-block',
        fontSize: '13px',
        fontWeight: 700,
        letterSpacing: '0.2px',
    },
    type_badge_issue: {
        color: theme.palette.error.main,
    },
    type_badge_evidence: {
        color: theme.palette.info.main,
    },
    type_badge_default: {
        color: theme.palette.grey[600],
    },
    attachment_description: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '6px',
        fontSize: '13px'
    },
    attachment_date: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '12px'
    },
    label: {
        fontWeight: 600,
        color: theme.palette.grey[700],
        whiteSpace: 'nowrap'
    },
    value: {
        color: theme.palette.grey[600],
        wordBreak: 'break-word'
    },
    empty: {
        "& $value, & $label": {
            fontStyle: 'italic',
            color: theme.palette.grey[400]
        }
    },
    no_attachments: {
        color: theme.palette.grey[400],
        fontStyle: 'italic',
        fontSize: '14px',
        padding: '16px',
        textAlign: 'center',
        width: '100%'
    }
}));

export { useStyles };
